import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import SelectProtocol from 'react-select/async';
import { custom_select } from 'assets/styles/multiple_select';
import { AiOutlineClear } from 'react-icons/ai';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import { MdPhoneForwarded } from 'react-icons/md';
import Loader from 'components/Loader';
import ClickToCall from '../../../../ServicePanel/components/AttendanceContent/components/Modal/ClickToCall';
import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style
} from '../../../../../assets/styles/table_custom_style';
import { apiChat } from '../../../../../http';
import SimpleHeader from '../../../../../components/Headers/SimpleHeader';
import { formatCurrency } from 'utils/fuctions/formatCurrency';
import { useProtocolDefaultFieldsSettings } from '../../../../fieldConfigs/hooks/useProtocolDefaultFieldsSettings';
import { dateRules } from '../../../assets';
import { functionsUseFul } from '../../assets/functionsUseFul';
import { useHandleProtocolListing } from '../../hooks/useHandleProtocolListing';
import { ClientNameWrapper } from '../ClientNameWrapper';
import FiltersForm from '../FiltersForm';
import { OutlineTooltip } from '../OutlineTooltip';
import ProtocolHistoryModal from '../ProtocolHistoryModal';
import { useSearchProtocols } from '../../hooks/useSearchProtocols';
import { ProtocolNumberWrapper } from '../ProtocolNumberWrapper';
import FlexTable from 'components/FlexTable';
import { useSelector } from 'react-redux';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import {
  EditProtocolByNumber,
  ProgressBar,
  ProgressBarContainer,
  ProgressBarBackground,
  NoPaddingDiv
} from './styled';
import { maskPhoneNumber } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { maskCpf } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { maskCnpj } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useListStatusByRecordType } from 'views/status/list/hooks/useListStatusByRecordType';
import { InfoCardProtocol } from '../InfoCard';
import ProtocolService from '../../../service';
import { ListView } from '../ListView';
import { FaLink } from 'react-icons/fa';
import { Graphics } from 'views/Report/Protocol/Synthetic/components/Graphics';
import styled from 'styled-components';
import {
  POSSIBLE_FILTERS_ENTITIES,
  useMemorizeFilters
} from '../../../../../hooks/useMemorizeInputsFilters';
import { KanbanProtocol } from '../../components/ProtocolList/components/kanbanProtocol';

import RecordTypeService from '../../../../RecordType/service';
import { getProgressBarColor } from 'utils/fuctions/getProgressBarColor';
import formattedTags from '../../utils/formattedTags';
import { IoIosStarOutline } from 'react-icons/io';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';

import Pagination from 'components/Pagination';
import { ClientProtocol } from 'views/Clients/list/components/ClientProtocol';
import { AccountProtocol } from 'views/CRM/Account/list/components/AccountProtocol';

const ProtocolFieldsFilterToggle = styled.div`
  display: inline-block;
  margin-right: 1rem;
  user-select: none;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const ProtocolListing = ({
  recordTypes,
  selectedRecordType,
  handleSelectedRecordTypeChange,
  isPageReloaded,
  hasChangedRecordType,
  setHasChangedRecordType,
  isListenerOnRecordType = false,
  setIsListenerOnRecordType,
  orderByFilter,
  setOrderByFilter,
  sortOrder,
  setSortOrder,
  sortDirection,
  setSortDirection
}) => {
  const selectedRecordTypeId = selectedRecordType.value;
  const history = useHistory();
  const location = useLocation();
  const formRef = useRef(null);
  const protocolListPath = useMemo(
    () => location.pathname.replace(/\/+$/, ''),
    [location.pathname]
  );
  const buildProtocolUpdatePath = useCallback(
    (protocolId) => `${protocolListPath}/${protocolId}/update`,
    [protocolListPath]
  );
  const { protocolDefaultFieldsDisplaySettings } =
    useProtocolDefaultFieldsSettings(selectedRecordTypeId);
  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.PROTOCOL,
    selectedRecordTypeId
  );

  const {
    protocols,
    protocolsQuantity,
    isLoadingProtocols,
    getProtocols,
    getProtocolOverallSLAInfoByRecordType,
    protocolOverallSLAInfo,
    formatParamsSLAParams,
    getAndReturnProtocolsKanban
  } = useHandleProtocolListing(selectedRecordTypeId);
  const { status, getStatusByRecordType } =
    useListStatusByRecordType(selectedRecordTypeId);

  const [selectedRows, setSelectedRows] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [dataField, setDataField] = useState();
  const [placement] = useState('bottom');
  const { buildProtocolTitleString } = functionsUseFul();
  const [disableClickToCall, setDisableClickToCall] = useState(true);
  const [orderByColumn, setOrderByColumn] = useState('');
  const [selectedView, setSelectedView] = useState('TABLE');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [typeReportSelected, setTypeReportSelected] = useState('Analítico');
  const [onlySubprotocols, setOnlySubprotocols] = useState(false);
  const { isSearching, filterProtocols } = useSearchProtocols(onlySubprotocols);
  const [dataGrafics, setDataGrafics] = useState();
  const [, setLoaderGrafics] = useState();
  const [showProtocolFilters, setShowProtocolFilters] = useState(true);

  const { memorizeFilters, getMemorizedFilters } = useMemorizeFilters(
    `${POSSIBLE_FILTERS_ENTITIES.PROTOCOL}`
  );

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [kanbanData, setKanbanData] = useState([]);
  const kanbanDataArray = Object.values(kanbanData).flat() ?? [];
  const [kanbanDataResponse, setKanbanDataResponse] = useState({});
  const [stagePageInfo, setStagePageInfo] = useState([]);
  const [stagePageInfoSplitView, setStagePageInfoSplitView] = useState([]);
  const [splitViewData, setSplitViewData] = useState([]);

  const [isLoadingKanban, setIsLoadingKanban] = useState(false);
  const [isLoadingSplitView, setIsLoadingsplitView] = useState(false);
  const [kanbanTotalQuantity, setKanbanTotalQuantity] = useState(0);

  const sizeKanban = 20;
  const sizeSplitView = 30;

  const [isRecordTypeUsingSLA, setIsRecordTypeUsingSLA] = useState(false);
  const [priorityToggling, setPriorityToggling] = useState({});

  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });

  useEffect(() => {
    if (!sortConfig?.key || !sortConfig?.direction) return;

    const newOrderBy = sortConfig.key;
    const newOrderType = sortConfig.direction === 'ascending' ? 'ASC' : 'DESC';

    setOrderByFilter(newOrderBy);
    setSortDirection(newOrderType);

    handleGetProtocols(
      {
        ...(dataField || {}),
        page: activePage,
        size: itemsPerPage || 10,
        order_by: newOrderBy,
        order_type: newOrderType
      },
      false,
      selectedView === 'KANBAN',
      selectedView === 'SPLIT'
    );
  }, [sortConfig]);

  const pageKey = useMemo(
    () => `flexTableConfig::[protocols::${selectedRecordTypeId}]`,
    [selectedRecordTypeId]
  );

  const formatColumnName = (name) => {
    return name.replace(/([A-Z])/g, '_$1').toLowerCase();
  };

  const settingsReady =
    !!protocolDefaultFieldsDisplaySettings &&
    Object.keys(protocolDefaultFieldsDisplaySettings).length >= 0;
  const customFieldsReady = customFields !== undefined;

  const columnsReady = settingsReady && customFieldsReady;

  useEffect(() => {
    const savedRecordType = localStorage.getItem('selectedRecordType');
    if (savedRecordType) {
      handleSelectedRecordTypeChange(JSON.parse(savedRecordType), {
        isReloadPage: false,
        cleanMemorizedFilters: false
      });
    }
  }, []);

  useEffect(() => {
    if (selectedRecordType) {
      localStorage.setItem(
        'selectedRecordType',
        JSON.stringify(selectedRecordType)
      );
    }
  }, [selectedRecordType]);

  useEffect(() => {
    if (!selectedRecordTypeId) return;

    const shouldReapplyFilters =
      sessionStorage.getItem('reapplyProtocolFilters') === 'true';
    if (shouldReapplyFilters) {
      return;
    }

    setStagePageInfoSplitView([]);
    setSplitViewData([]);
    setKanbanData([]);
    setStagePageInfo([]);
    getStatusByRecordType(selectedRecordTypeId);
    let filters = getMemorizedFilters();

    const filteredCustomFields = getFilteredCustomFieldsListType();

    const page = filters?.page || activePage;

    const size = filters?.size ? Number(filters.size) : itemsPerPage;

    setItemsPerPage(size);

    if (filters && 'has_priority' in filters && !filters.has_priority) {
      // eslint-disable-next-line no-unused-vars
      const { has_priority, ...rest } = filters;
      filters = { ...rest };
    }

    setItemsPerPage(size);

    let filterDto = { ...filters };

    const hasSavedFilters =
      filters &&
      Object.keys(filters).some((key) =>
        [
          'reason_id',
          'subreason_id',
          'current_status',
          'current_responsible',
          'service_channel'
        ].includes(key)
      );

    if (!isPageReloaded && isListenerOnRecordType && !hasSavedFilters) {
      const keysToRemove = new Set([
        'reason_id',
        'subreason_id',
        'current_status',
        'idChannel',
        'current_responsible',
        'service_channel',
        'matrixSLA',
        'impact',
        'criticality',
        'slaAtendimento',
        'slaSolucao',
        ...filteredCustomFields
      ]);

      filterDto = Object.fromEntries(
        Object.entries(filterDto).filter(([key]) => !keysToRemove.has(key))
      );
    }

    let order_by = 'creation_date';
    let order_type = 'DESC';

    try {
      const cfg = JSON.parse(localStorage.getItem(pageKey)) || [];

      const sortCfg = cfg.find((c) => c.isSort);
      if (sortCfg?.key && sortCfg?.sortDirection) {
        order_by = String(sortCfg.key)
          .replace(/([A-Z])/g, '_$1')
          .toLowerCase();
        order_type = sortCfg.sortDirection === 'ascending' ? 'ASC' : 'DESC';
        setSortConfig({ key: sortCfg.key, direction: sortCfg.sortDirection });
      }
    } catch (err) {
      console.warn('Erro ao ler config da FlexTable', err);
    }

    const updatedFilterDto = {
      ...filterDto,
      page,
      order_by,
      order_type,
      size
    };

    setDataField(updatedFilterDto);

    if (selectedView === 'TABLE') {
      const internalFields = [
        'showDateIntervalForm',
        'showAdvancedSearchForm',
        'selectedRecordType',
        'viewMode',
        'recordTypeId',
        'account',
        'showProtocolFilters',
        'columnsOrder',
        'hiddenColumns'
      ];

      let cleanedFilterByDateInterval = Object.fromEntries(
        Object.entries(updatedFilterDto || {}).filter(
          ([key, value]) =>
            !internalFields.includes(key) &&
            value !== undefined &&
            value !== null &&
            value !== ''
        )
      );

      if (filters?.showDateIntervalForm === false) {
        const { dateBegin, dateEnd, ...rest } = cleanedFilterByDateInterval;
        cleanedFilterByDateInterval = rest;
      }

      getProtocols(
        {
          ...cleanedFilterByDateInterval,
          size
        },
        false
      );
    }
    if (selectedView === 'KANBAN') {
      getAndReturnProtocolsKanban({
        ...(filterDto || {}),
        page,
        size: sizeKanban
      });
    }

    getProtocolOverallSLAInfoByRecordType({
      ...(filterDto || {}),
      page: undefined,
      size: undefined,
      order_by: 'creation_date',
      order_type: 'DESC'
    });

    // eslint-disable-next-line no-prototype-builtins
    if (filters?.hasOwnProperty('showProtocolFilters')) {
      setShowProtocolFilters(filters?.showProtocolFilters);
    }
  }, [getStatusByRecordType, getMemorizedFilters, selectedRecordTypeId]);

  useEffect(() => {
    const shouldReapply =
      sessionStorage.getItem('reapplyProtocolFilters') === 'true';

    if (shouldReapply && selectedRecordTypeId) {
      sessionStorage.removeItem('reapplyProtocolFilters');

      const filters = getMemorizedFilters();

      if (
        filters &&
        (filters.current_status ||
          filters.reason_id ||
          filters.current_responsible)
      ) {
        setTimeout(() => {
          handleGetProtocols(filters, false);
        }, 100);
      }
    }
  }, [selectedRecordTypeId, getMemorizedFilters, handleGetProtocols]);

  useEffect(() => {
    if (selectedRecordTypeId && itemsPerPage) {
      const currentFilters = getMemorizedFilters();
      if (currentFilters?.size !== itemsPerPage) {
        memorizeFilters({
          ...currentFilters,
          recordTypeId: selectedRecordTypeId,
          size: itemsPerPage
        });
      }
    }
  }, [
    itemsPerPage,
    selectedRecordTypeId,
    memorizeFilters,
    getMemorizedFilters
  ]);

  useEffect(() => {
    if (!selectedRecordTypeId) return;
    RecordTypeService.getById(selectedRecordTypeId)
      .then((response) => {
        const recordType = response.data.content;
        if (recordType) {
          setIsRecordTypeUsingSLA(recordType.is_sla_active);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedRecordTypeId]);

  const telephonyServicePanel = useSelector(
    (state) => state.telephonyServicePanel
  );

  useEffect(() => {
    const copy = [...selectedRows];
    copy.splice(0, selectedRows.length);
    setSelectedRows(copy);
  }, [selectedRecordType]);

  const canSeeAllProtocols = useMemo(() => {
    const flag = localStorage.getItem('show_all_protocols');
    return flag === 'true';
  }, []);

  const acessToken = useMemo(() => {
    const initialToken = localStorage.getItem('token');
    const finalToken = `Bearer ${initialToken}`;
    return finalToken;
  }, []);

  const getFilteredCustomFieldsListType = useCallback(() => {
    return customFields
      .filter((field) => field.type === 'MULTIPLE' || field.type === 'LIST')
      .map((field) => field.name);
  }, [customFields, getCustomFields]);

  const handleHeaderCheckboxChange = (e) => {
    const isChecked = e.target.checked;

    const allRowIds = protocols.map((r) => ({
      id: r.id,
      current_status: r.current_status ? r.current_status : null,
      number: r.number ? r.number : null,
      current_responsible: r.current_responsible ? r.current_responsible : null,
      account_id: r.account_id ? r.account_id : null,
      has_unread_comments: r?.has_unread_comments ?? null
    }));

    if (isChecked) {
      const newSelection = allRowIds.filter(
        (item) => !selectedRows.some((selected) => selected.id === item.id)
      );
      setSelectedRows([...selectedRows, ...newSelection]);
    } else {
      setSelectedRows([]);
    }
  };

  const handleSearchKanban = async (searchFilters, newStageInfo = null) => {
    getAndReturnProtocolsKanban({
      ...searchFilters,
      page: 1,
      size: newStageInfo ? newStageInfo?.currentPage * sizeKanban : sizeKanban
    }).then((response) => {
      setKanbanDataResponse(response);
      const { content, quantityKamban, quantity } = response.data;

      setKanbanTotalQuantity(quantity || 0);

      const kanbanArray = Object.entries(content).map(
        ([stageId, protocols]) => {
          const actualStageId = stageId === 'no_status' ? 'no_status' : stageId;
          const stage = status.find((s) => s.id === actualStageId) || {
            id: 'no-status',
            name: 'Sem Status'
          };
          const count =
            quantityKamban.find(
              (q) =>
                q.id === stageId || (stageId === 'no_status' && q.id === null)
            )?.quantidade || protocols.length;
          return {
            id: stage.id,
            name: stage.name,
            protocols,
            count: parseInt(count, 10),
            currentPage: 1
          };
        }
      );

      setStagePageInfo(
        kanbanArray.map(({ id, name, count, currentPage }) => ({
          id,
          name,
          count,
          currentPage
        }))
      );

      setKanbanData(kanbanArray);
    });
  };

  const handleSearchSplitView = (searchFilters) => {
    // ele chama a mesma função que o kanban, mas com um tamanho diferente
    getAndReturnProtocolsKanban({
      ...searchFilters,
      page: 1,
      size: sizeSplitView
    }).then((response) => {
      const { content, quantityKamban, quantity } = response.data;

      setKanbanTotalQuantity(quantity || 0);

      const splitScreenArray = Object.entries(content).map(
        ([stageId, protocols]) => {
          const actualStageId = stageId === 'no_status' ? 'no_status' : stageId;
          const stage = status.find((s) => s.id === actualStageId) || {
            id: 'no-status',
            name: 'Sem Status'
          };
          const count =
            quantityKamban.find(
              (q) =>
                q.id === stageId || (stageId === 'no_status' && q.id === null)
            )?.quantidade || protocols.length;
          return {
            id: stage.id,
            name: stage.name,
            protocols,
            count: parseInt(count, 10),
            currentPage: 1
          };
        }
      );

      setStagePageInfoSplitView(
        splitScreenArray.map(({ id, name, count, currentPage }) => ({
          id,
          name,
          count,
          currentPage
        }))
      );

      setSplitViewData(splitScreenArray);
    });
  };

  const handleGetProtocols = useCallback(
    async (
      params = {},
      showToastMessage = true,
      isKanban = false,
      isSplitView = false
    ) => {
      const internalFields = [
        'showDateIntervalForm',
        'showAdvancedSearchForm',
        'selectedRecordType',
        'viewMode',
        'recordTypeId',
        'account',
        'showProtocolFilters',
        'columnsOrder',
        'hiddenColumns'
      ];

      const cleanedParams = Object.fromEntries(
        Object.entries(params).filter(([key]) => !internalFields.includes(key))
      );

      const updatedParams = {
        ...cleanedParams,
        order_by: cleanedParams?.order_by || orderByFilter,
        order_type: cleanedParams?.order_type || sortDirection
      };

      setDataField(updatedParams);

      if (isKanban) {
        await handleSearchKanban(updatedParams, null);
        return;
      }
      if (isSplitView) {
        handleSearchSplitView(updatedParams);
        return;
      }
      await getProtocols(updatedParams, showToastMessage);
    },
    [
      getProtocols,
      handleSearchKanban,
      handleSearchSplitView,
      orderByFilter,
      sortDirection
    ]
  );

  const handleGetProtocolsOverallSLAInfo = useCallback(
    async (params = {}) => {
      setDataField({ ...params });
      getProtocolOverallSLAInfoByRecordType(params);
    },
    [getProtocolOverallSLAInfoByRecordType]
  );

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    if (telephonyServicePanel.extension === '') {
      setDisableClickToCall(true);
    } else {
      setDisableClickToCall(false);
    }
  }, [telephonyServicePanel]);

  const handleCall = useCallback(
    (row) => {
      let telephoneWithoutSpecialCharacters =
        row.telephone && row.telephone !== ''
          ? row.telephone.replace(/\D/g, '')
          : '';
      let clientTelephoneWithoutSpecialCharacters =
        row.telefoneCliente && row.telefoneCliente !== ''
          ? row.telefoneCliente.replace(/\D/g, '')
          : '';
      const data = {
        origem: telephonyServicePanel.extension,
        destino:
          row.telephone && row.telephone !== ''
            ? telephoneWithoutSpecialCharacters
            : clientTelephoneWithoutSpecialCharacters
      };
      if (disableClickToCall) {
        toast.error(
          'É necessário estar logado em um ramal para realizar a chamada!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      } else {
        if (!window.confirm('Tem certeza que deseja realizar a chamada agora?'))
          return;

        apiChat
          .post(`/clicktocall`, data)
          .then(() => {
            toast.success('Realizando chamada!', {
              autoClose: 3000,
              closeOnClick: true
            });
          })
          .catch((err) => {
            toast.error(err.response.data.msg || 'Erro ao realizar chamada!');
          });
      }
    },
    [disableClickToCall, telephonyServicePanel.extension]
  );

  const handleUpdate = useCallback(
    (id) => {
      const values = {
        recordTypeId: selectedRecordTypeId,
        returnPath: '/admin/protocol'
      };
      const objetoString = JSON.stringify(values);
      localStorage.setItem('valueRoute', objetoString);

      const filters = getMemorizedFilters();

      if (
        filters &&
        (filters.current_status ||
          filters.reason_id ||
          filters.current_responsible)
      ) {
        sessionStorage.setItem('reapplyProtocolFilters', 'true');
      }

      history.push(`/admin/protocol/${id}/update`);
    },
    [
      history,
      selectedRecordTypeId,
      getMemorizedFilters,
      protocolListPath,
      buildProtocolUpdatePath
    ]
  );

  const handlePageChange = (activePage) => {
    const currentFilters = getMemorizedFilters();
    const size = currentFilters?.size ? currentFilters.size : itemsPerPage;
    getProtocols({
      ...(dataField || {}),
      filterColumn: orderByColumn,
      page: activePage,
      size,
      order_by: orderByFilter,
      order_type: sortDirection
    });
    memorizeFilters({
      ...currentFilters,
      page: activePage,
      order_by: orderByFilter,
      order_type: sortDirection
    });
    setActivePage(activePage);
  };

  function removeMultipleParams(obj) {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([, value]) => !Array.isArray(value) || value.length > 0
      )
    );
  }

  const getMediaPath = useCallback(
    (media) => {
      try {
        const [, jwt] = acessToken.split(' ');
        let formattedDataField = formatParamsSLAParams(dataField);
        formattedDataField = formattedTags(formattedDataField);
        const dataFieldWithoutMultipleParams =
          removeMultipleParams(formattedDataField);

        const paramsAsString = new URLSearchParams();

        for (const key in dataFieldWithoutMultipleParams) {
          const value = dataFieldWithoutMultipleParams[key];
          if (
            value === null ||
            value === undefined ||
            value === '' ||
            (Array.isArray(value) && value.length === 0)
          ) {
            continue;
          }
          if (Array.isArray(value)) {
            value.forEach((element) => {
              if (element !== null && element !== undefined) {
                paramsAsString.append(`${key}[]`, element);
              }
            });
          } else if (typeof value === 'object' && !Array.isArray(value)) {
            paramsAsString.append(key, JSON.stringify(value));
          } else {
            paramsAsString.append(key, value);
          }
        }

        const columnConfig = JSON.parse(localStorage.getItem(pageKey)) || [];

        const orderByConfig = columnConfig.find((col) => col.isSort);
        const orderBy = orderByConfig
          ? formatColumnName(
              orderByConfig.key === 'phone' ? 'telephone' : orderByConfig.key
            )
          : null;

        const orderType = orderByConfig
          ? orderByConfig.sortDirection === 'ascending'
            ? 'ASC'
            : 'DESC'
          : null;

        if (orderBy) paramsAsString.append('orderBy', orderBy);
        if (orderType) paramsAsString.append('orderType', orderType);

        const hiddenColumns = (columnConfig || [])
          .filter((col) => !col.visible)
          .map((col) => formatColumnName(col.key));

        if (hiddenColumns.length) {
          hiddenColumns.forEach((h) =>
            paramsAsString.append('hiddenColumns[]', h)
          );
        }

        const columnsConfig = localStorage.getItem(pageKey);
        const columnsOrder = columnsConfig
          ? JSON.parse(columnsConfig).map((col) => formatColumnName(col.key))
          : [];

        paramsAsString.append('columnsOrder', encodeURIComponent(columnsOrder));

        paramsAsString.append('jwt', jwt);

        const queryURL = `${process.env.REACT_APP_CASE_URL}protocols/export/${media}/${selectedRecordTypeId}?${paramsAsString}`;
        return queryURL;
      } catch (err) {
        toast.error('Ops, ocorreu um erro ao realizar o download do arquivo!', {
          autoClose: 3000,
          closeOnClick: true
        });
      }
    },
    [acessToken, dataField, selectedRecordTypeId, pageKey]
  );

  const selectProtocol = {
    formatExtraData: selectedRows,

    headerFormatter: () => {
      return (
        <input
          defaultValue={false}
          checked={protocols?.every((obj) =>
            selectedRows.some((row) => row.id === obj.id)
          )}
          type="checkbox"
          onChange={handleHeaderCheckboxChange}
        ></input>
      );
    },
    style: individual_column_style,
    formatter: (_, row, rowIndex, formatExtraData) => {
      const isChecked = formatExtraData.some((item) => item.id === row.id);
      return (
        <input
          checked={isChecked}
          onChange={(value) => {
            const id = row.id;
            const currentStatus = row.current_status;
            const number = row.number;
            const current_responsible = row.current_responsible;
            const account_id = row.account_id;
            const has_unread_comments = row.has_unread_comments;

            const newItem = {
              id,
              currentStatus,
              number,
              current_responsible,
              account_id,
              has_unread_comments
            };

            if (value.target.checked && !isChecked) {
              const copy = [...formatExtraData, newItem];
              setSelectedRows(copy);
            } else if (!value.target.checked && isChecked) {
              const copy = formatExtraData.filter((item) => item.id !== id);
              setSelectedRows(copy);
            }
          }}
          value={row.id}
          type="checkbox"
        />
      );
    }
  };

  const createDynamicColumns = useCallback(() => {
    const columns = [
      {
        key: 'has_priority',
        dataField: 'has_priority',
        text: 'Prioridade',
        sort: false,
        style: individual_column_style,
        formatter: (_, row) => {
          const { has_priority, id } = row;
          const isToggling = !!priorityToggling[id];

          const activeColor = '#FFD600';
          const inactiveColor = '#A0B4C4';

          const handleTogglePriority = async (e) => {
            e.stopPropagation();
            if (isToggling) return;
            setPriorityToggling((prev) => ({ ...prev, [id]: true }));
            try {
              await ProtocolService.toggleProtocolPriority(id);
              row.has_priority = !has_priority;
              toast.success(
                !has_priority ? 'Prioridade ativada!' : 'Prioridade removida!',
                { autoClose: 2000 }
              );
            } catch (err) {
              toast.error('Erro ao atualizar prioridade!');
            } finally {
              setPriorityToggling((prev) => ({ ...prev, [id]: false }));
            }
          };

          return (
            <button
              style={{
                background: 'none',
                border: 'none',
                cursor: isToggling ? 'wait' : 'pointer',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                margin: '0 auto',
                transition: 'filter 0.2s',
                filter: isToggling ? 'grayscale(0.5) blur(1px)' : 'none'
              }}
              title={has_priority ? 'Prioridade' : 'Sem prioridade'}
              type="button"
              onClick={handleTogglePriority}
              disabled={isToggling}
            >
              <IoIosStarOutline
                size={22}
                color={has_priority ? activeColor : inactiveColor}
                style={{
                  fill: has_priority ? activeColor : inactiveColor,
                  stroke: has_priority ? activeColor : inactiveColor,
                  strokeWidth: 1.5,
                  transition: 'color 0.3s, fill 0.3s, stroke 0.3s',
                  filter: isToggling ? 'grayscale(0.5) blur(1px)' : 'none',
                  transform: isToggling ? 'scale(1.1)' : 'scale(1)',
                  transitionProperty: 'color, fill, stroke, transform',
                  transitionDuration: '0.3s',
                  transitionTimingFunction: 'ease-in-out'
                }}
              />
            </button>
          );
        }
      },
      {
        key: 'has_unread_comments',
        dataField: 'has_unread_comments',
        text: 'Possui comentários não lidos',
        sort: false,
        style: individual_column_style,
        formatter: (_, row) => {
          const { has_unread_comments: hasUnreadComments, id } = row;
          const activeColor = '#FF0000';
          const inactiveColor = '#A0B4C4';
          const userId = localStorage.getItem('login');

          const handleToggleReadStatus = async (e) => {
            e.stopPropagation();
            try {
              if (hasUnreadComments) {
                // Marcar como lido
                await ProtocolService.markProtocolsCommentsAsRead({
                  protocols: [id],
                  userId
                });

                toast.success('Comentários marcados como lidos!', {
                  autoClose: 2000
                });
              } else {
                // Marcar como não lido
                await ProtocolService.markProtocolsCommentsAsUnread({
                  protocols: [id],
                  userId
                });

                toast.success('Comentários marcados como não lidos!', {
                  autoClose: 2000
                });
              }

              await handleGetProtocols(
                {
                  ...dataField,
                  page: activePage,
                  size: itemsPerPage
                },
                false
              );
            } catch (err) {
              console.error(err);
              toast.error(
                'Erro ao mudar o status de leitura dos comentários do protocolo',
                { autoClose: 3000 }
              );
            }
          };

          return (
            <button
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                margin: '0 auto',
                transition: 'filter 0.2s'
              }}
              title={
                hasUnreadComments ? 'Marcar como lido' : 'Marcar como não lido'
              }
              type="button"
              onClick={handleToggleReadStatus}
            >
              {hasUnreadComments ? (
                <FaRegEyeSlash
                  size={22}
                  color={activeColor}
                  style={{
                    transition: 'color 0.3s, fill 0.3s, stroke 0.3s',
                    transitionProperty: 'color, fill, stroke, transform',
                    transitionDuration: '0.3s',
                    transitionTimingFunction: 'ease-in-out'
                  }}
                />
              ) : (
                <FaRegEye
                  size={22}
                  color={inactiveColor}
                  style={{
                    transition: 'color 0.3s, fill 0.3s, stroke 0.3s',
                    transitionProperty: 'color, fill, stroke, transform',
                    transitionDuration: '0.3s',
                    transitionTimingFunction: 'ease-in-out'
                  }}
                />
              )}
            </button>
          );
        }
      },
      {
        key: 'number',
        dataField: 'number',
        text: 'Número',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          const showIcon = !!row?.parent_id || !!row?.subProtocols?.length;
          const { number, description } = row;
          return (
            <Link
              to={`/admin/protocol/${row.id}/update`}
              onClick={() => handleUpdate(row.id)}
            >
              <EditProtocolByNumber
                style={{ color: '#515151' }}
                onClick={() => handleUpdate(row.id)}
                title={`Clique para editar o protocolo ${number}`}
              >
                {showIcon && <FaLink style={{ marginRight: '3px' }}></FaLink>}
                <ProtocolNumberWrapper
                  number={number}
                  description={description}
                  onClick={() => handleUpdate(row.id)}
                  isDescriptionShown={
                    protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.description &&
                    protocolDefaultFieldsDisplaySettings.description.isRequired
                  }
                />
              </EditProtocolByNumber>
            </Link>
          );
        }
      }
    ];

    if (
      protocolDefaultFieldsDisplaySettings &&
      Object.keys(protocolDefaultFieldsDisplaySettings).length
    ) {
      if (protocolDefaultFieldsDisplaySettings.title.isActive) {
        columns.push({
          key: 'title',
          dataField: 'title',
          text: 'Título',
          sort: true,
          style: individual_column_style,
          // eslint-disable-next-line react/display-name
          formatter: (_, row) => {
            return (
              <>
                <div>
                  <span id={`title-${row.id}`}>{row.title ?? ''} </span>
                  <OutlineTooltip
                    placement={placement}
                    target={`title-${row.id}`}
                    message={row.title}
                  />
                </div>
              </>
            );
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        Object.keys(protocolDefaultFieldsDisplaySettings).length
      ) {
        if (protocolDefaultFieldsDisplaySettings.current_status.isActive) {
          columns.push({
            key: 'status',
            dataField: 'status',
            text: 'Status/Fase',
            sort: true,
            style: individual_column_style,
            formatter: (_, row) => {
              const { nomeStatus, corStatus } = row;
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <>
                    <div
                      style={{
                        marginRight: '5px',
                        width: '12px',
                        height: '12px',
                        border: '1px solid #CDC9C9',
                        backgroundColor: `${corStatus}`
                      }}
                    ></div>
                    <div>{`${nomeStatus}`}</div>
                  </>
                </div>
              );
            }
          });
        }
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.client_id.isActive
      ) {
        columns.push({
          key: 'client',
          dataField: 'cliente',
          text: 'Contato',
          sort: true,
          style: individual_column_style,
          formatter: (_, row) => {
            const { nomeCliente, telefoneCliente, emailCliente } = row;
            return (
              <ClientNameWrapper
                name={nomeCliente}
                telephone={telefoneCliente}
                email={emailCliente}
              />
            );
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.account_id.isActive
      ) {
        columns.push({
          key: 'account',
          dataField: 'nomeConta',
          text: 'Conta',
          sort: true,
          style: individual_column_style,
          formatter: (_, row) => {
            const { nomeConta } = row;
            return nomeConta || '';
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.reason_id.isActive
      ) {
        columns.push({
          key: 'reason',
          dataField: 'nomeMotivo',
          text: 'Motivo',
          sort: true,
          style: individual_column_style
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.subreason_id.isActive
      ) {
        columns.push({
          key: 'subreason',
          dataField: 'nomeSubmotivo',
          text: 'Submotivo',
          sort: true,
          style: individual_column_style
        });
      }

      columns.push({
        key: 'creation_date',
        dataField: 'creation_date',
        text: 'Criação',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (!row.creation_date) {
            return '';
          }
          const date = new Date(row.creation_date);
          return `${date.toLocaleDateString(
            'pt-BR'
          )} às ${date.toLocaleTimeString('pt-BR', {
            timeZone: 'America/Fortaleza'
          })}`;
        }
      });

      columns.push({
        key: 'responsible',
        dataField: 'nomeResponsavel',
        text: 'Responsável',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          return row.nomeResponsavel || 'Sem responsável';
        }
      });

      columns.push({
        key: 'last_change_date',
        dataField: 'last_change_date',
        text: 'Última Alteração',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          const date = new Date(row.last_change_date);
          return `${date.toLocaleDateString(
            'pt-BR'
          )} às ${date.toLocaleTimeString('pt-BR', {
            timeZone: 'America/Fortaleza'
          })}`;
        }
      });
    }

    (customFields || []).forEach((field) => {
      columns.push({
        key: field.name,
        dataField: field.name,
        text: field.label,
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (field.type === 'DATE' && !!row[field.name]) {
            return new Date(row[field.name]).toLocaleDateString('pt-br');
          }

          if (field.type === 'CURRENCY' && !!row[field.name]) {
            return formatCurrency(row[field.name]);
          }

          if (field.type === 'TELEPHONE' && !!row[field.name]) {
            return maskPhoneNumber(row[field.name]);
          }

          if (field.type === 'CPF' && !!row[field.name]) {
            return maskCpf(row[field.name]);
          }

          if (field.type === 'CNPJ' && !!row[field.name]) {
            return maskCnpj(row[field.name]);
          }

          if (field.type === 'MULTIPLE' && !!row[field.name]) {
            return row[field.name].replace(/;/g, '; ');
          }

          return row[`${field.name}`];
        }
      });
    });

    return columns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    customFields,
    protocolDefaultFieldsDisplaySettings,
    buildProtocolTitleString,
    placement,
    handleUpdate,
    priorityToggling,
    handleGetProtocols
  ]);

  const createSLAColumn = useCallback(() => {
    if (!isRecordTypeUsingSLA) {
      return [];
    }
    const slaColumns = [
      {
        key: 'service_classification_name',
        dataField: 'service_classification_name',
        text: 'Classificação de Serviço',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) =>
          row.sla_info ? row.sla_info.service_classification_name || '-' : '-'
      },
      {
        key: 'serviceTime',
        dataField: 'serviceTime',
        text: 'SLA de Atendimento',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (row.sla_info && Object.keys(row.sla_info).length) {
            const { serviceTime, remainingServiceTime } = row.sla_info;
            let percentage = (remainingServiceTime / serviceTime) * 100;
            percentage = Math.max(0, Math.min(percentage, 100));
            const color = getProgressBarColor(percentage);
            return (
              <ProgressBarContainer>
                {`${percentage.toFixed(2)}%`}
                <ProgressBarBackground>
                  <ProgressBar percentage={percentage} color={color} />
                </ProgressBarBackground>
              </ProgressBarContainer>
            );
          }
          return '-';
        }
      },
      {
        key: 'solutionTime',
        dataField: 'solutionTime',
        text: 'SLA de Solução',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (row.sla_info && Object.keys(row.sla_info).length) {
            const { solutionTime, remainingSolutionTime } = row.sla_info;
            let percentage = (remainingSolutionTime / solutionTime) * 100;
            percentage = Math.max(0, Math.min(percentage, 100));
            const color = getProgressBarColor(percentage);
            return (
              <ProgressBarContainer>
                {`${percentage.toFixed(2)}%`}
                <ProgressBarBackground>
                  <ProgressBar percentage={percentage} color={color} />
                </ProgressBarBackground>
              </ProgressBarContainer>
            );
          }
          return '-';
        }
      }
    ];
    return slaColumns;
  }, [isRecordTypeUsingSLA]);

  const formatColumn = useCallback(() => {
    const dinamicColumns = createDynamicColumns();
    const slaColumns = createSLAColumn();

    const callColumn = {
      key: 'call',
      dataField: 'call',
      text: 'Chamar',
      style: icon_column_style,
      formatter: (_, row) => {
        return (
          <ClickToCall
            title={
              row?.telefoneCliente !== '' || row.telephone !== ''
                ? `Chamar cliente ${row?.nomeCliente}\nÉ necessário estar logado em um ramal para realizar a chamada!`
                : `O cliente ${row?.nomeCliente} não possui telefone cadastrado`
            }
            callBack={() => handleCall(row)}
            disableClickToCall={
              (row?.telefoneCliente !== '' || row?.telephone !== '') &&
              !disableClickToCall
                ? false
                : true
            }
            icon={<MdPhoneForwarded size={17} color="#fff" />}
            color="success"
            isDefaultButtonStyle={true}
          />
        );
      }
    };

    const editeColumn = {
      key: 'edit',
      dataField: 'edit',
      text: 'Editar',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return (
          <Link to={`/admin/protocol/${row.id}/update`}>
            <Button
              title="Editar protocolo"
              color="info"
              size="sm"
              onClick={() => handleUpdate(row.id)}
            >
              <li className="fas fa-user-edit"></li>
            </Button>
          </Link>
        );
      }
    };

    const historyContactColumn = {
      key: 'historyContact',
      dataField: 'historyContact',
      text: 'Historico de Contato',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return (
          <ClientProtocol recordTypes={recordTypes} clientId={row.client_id} />
        );
      }
    };

    const historyAccountColumn = {
      key: 'historyAccount',
      dataField: 'historyAccount',
      text: 'Historico da Conta',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return <AccountProtocol accountId={row.account_id} />;
      }
    };

    const historyColumn = {
      key: 'history',
      dataField: 'history',
      text: 'Histórico',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return <ProtocolHistoryModal protocolId={row.id} />;
      }
    };

    return [
      ...dinamicColumns,
      ...slaColumns,
      editeColumn,
      historyColumn,
      historyContactColumn,
      historyAccountColumn,
      callColumn
    ];
  }, [
    createDynamicColumns,
    createSLAColumn,
    disableClickToCall,
    handleCall,
    handleUpdate
  ]);

  const tableColumns = useMemo(
    () => formatColumn(),
    [
      createDynamicColumns,
      createSLAColumn,
      customFields,
      protocolDefaultFieldsDisplaySettings
    ]
  );
  const tableKey = useMemo(
    () =>
      `protocols-${selectedRecordTypeId}-${tableColumns
        .map((c) => c.key)
        .join('|')}`,
    [selectedRecordTypeId, tableColumns]
  );

  const handleSortProtocolTable = useCallback(
    async (ordenationParam, sortOrder) => {
      setSortDirection(sortOrder);
      setOrderByFilter(ordenationParam);
      await handleGetProtocols({
        ...dataField,
        page: activePage,
        size: itemsPerPage || 10,
        order_by: ordenationParam || orderByFilter,
        order_type: sortOrder || sortDirection
      });
    },
    [activePage, dataField, handleGetProtocols, itemsPerPage]
  );

  const onTableGrow = async (stageId) => {
    if (isLoadingKanban) return;
    setIsLoadingKanban(true);
    try {
      const stageInfo = stagePageInfo.find((item) => item.id === stageId);
      const page = stageInfo ? stageInfo.currentPage : 0;
      if (!page) {
        return;
      }

      const response = await getAndReturnProtocolsKanban({
        ...dataField,
        current_status: [stageId],
        page: page + 1,
        size: sizeKanban
      });

      const newProtocols = response.data.content[stageId] || [];

      setKanbanData((prev) => {
        return prev.map((stage) => {
          if (stage.id === stageId) {
            return {
              ...stage,
              protocols: [...stage.protocols, ...newProtocols]
            };
          }
          return stage;
        });
      });

      setStagePageInfo((prev) => {
        return prev.map((item) => {
          if (item.id === stageId) {
            return {
              ...item,
              currentPage: page + 1
            };
          }
          return item;
        });
      });

      setIsLoadingKanban(false);
    } catch (error) {
      console.error(error);
      setIsLoadingKanban(false);
    }
  };

  const onTableGrowSplitView = async (stageId) => {
    if (isLoadingSplitView) return;
    setIsLoadingsplitView(true);
    try {
      const stageInfo = stagePageInfoSplitView.find(
        (item) => item.id === stageId
      );
      const page = stageInfo ? stageInfo.currentPage : 0;
      if (!page) {
        return;
      }

      const response = await getAndReturnProtocolsKanban({
        ...dataField,
        current_status: [stageId],
        page: page + 1,
        size: sizeSplitView
      });

      const newProtocols = response.data.content[stageId] || [];

      setSplitViewData((prev) => {
        return prev.map((stage) => {
          if (stage.id === stageId) {
            return {
              ...stage,
              protocols: [...stage.protocols, ...newProtocols]
            };
          }
          return stage;
        });
      });

      setStagePageInfoSplitView((prev) => {
        return prev.map((item) => {
          if (item.id === stageId) {
            return {
              ...item,
              currentPage: page + 1
            };
          }
          return item;
        });
      });

      setIsLoadingsplitView(false);
    } catch (error) {
      console.error(error);
      setIsLoadingsplitView(false);
    }
  };

  const onTableChange = async (protocolId, status_id, _, oldStageId) => {
    try {
      await ProtocolService.protocolUpdateData(
        protocolId,
        { status_id },
        'change_status'
      );

      const oldStage = oldStageId;
      const newStage = status_id;

      const newStageInfo = stagePageInfo.find((item) => item.id === newStage);
      await handleSearchKanban(dataField, newStageInfo);

      const result = kanbanDataResponse || [];

      if (!result?.data?.content || !result?.data?.quantityKamban) {
        toast.error('Resposta inválida do servidor');
        return false;
      }

      setKanbanData((prevKanban) => {
        const contentArray = Object.entries(result.data.content).map(
          ([id, protocols]) => ({
            id,
            protocols,
            ...stagePageInfo.find((stage) => stage.id === id)
          })
        );
        return prevKanban.map((stage) => {
          const updatedStage = contentArray.find((s) => s.id === stage.id);
          if (stage.id === oldStage) {
            return {
              ...stage,
              protocols: stage.protocols.filter((p) => p.id !== protocolId),
              count: stage.count - 1
            };
          }
          if (stage.id === newStage) {
            return {
              ...stage,
              protocols: updatedStage?.protocols || stage.protocols,
              count: updatedStage?.count || stage.count
            };
          }
          return stage;
        });
      });

      setStagePageInfo((prev) =>
        prev.map((stage) => {
          const quantity = result.data.quantityKamban.find(
            (q) =>
              q.id === stage.id || (stage.id === 'no-status' && q.id === null)
          );

          return quantity
            ? { ...stage, count: parseInt(quantity.quantidade) }
            : stage;
        })
      );

      return true;
    } catch (error) {
      toast.error('Erro na atualização: ' + error.message, {
        autoClose: 3000,
        draggable: false
      });
      return false;
    }
  };

  const isToShowProtocolFiltersForm = (showProtocolFilters) => {
    const filters = getMemorizedFilters();
    const isToShow = !showProtocolFilters;

    if (filters) {
      filters.showProtocolFilters = isToShow;
    }

    setShowProtocolFilters(!showProtocolFilters);
    memorizeFilters(filters);
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <h3 className="mb-0">Protocolos</h3>
                    <NoPaddingDiv className="col-5">
                      <SelectProtocol
                        styles={{
                          ...custom_select,
                          control: (provided) => ({
                            ...provided,
                            borderRadius: '0',
                            border: 'none',
                            borderBottom: '1px solid #ccc',
                            boxShadow: 'none',
                            '&:hover': {
                              borderBottom: '1px solid #aaa'
                            }
                          }),
                          input: (provided) => ({
                            ...provided,
                            border: 'none',
                            boxShadow: 'none'
                          })
                        }}
                        placeholder="Encontrar protocolo"
                        isClearable={true}
                        name="protocol_id"
                        isLoading={isSearching}
                        loadingMessage={() => 'Buscando...'}
                        noOptionsMessage={({ inputValue }) =>
                          !inputValue
                            ? 'Digite para pesquisar'
                            : 'Nenhum resultado encontrado'
                        }
                        components={{
                          DropdownIndicator: () => null,
                          IndicatorSeparator: () => null
                        }}
                        loadOptions={async (inputValue) => {
                          const res = await filterProtocols(
                            inputValue,
                            recordTypes.map((recordType) => recordType.id)
                          );
                          return (
                            res &&
                            res.map((protocol) => ({
                              label: (
                                <div style={{ fontSize: '1rem' }}>
                                  <strong>Número:</strong>{' '}
                                  {protocol.number || 'N/A'} <br />
                                  <strong>Título:</strong>{' '}
                                  {protocol.title?.length > 50
                                    ? `${protocol.title.slice(0, 50)}...`
                                    : protocol.title || 'N/A'}{' '}
                                  <br />
                                  <strong>Descrição:</strong>{' '}
                                  {protocol.description
                                    ? (() => {
                                        const cleanDescription =
                                          protocol.description.replace(
                                            /<\/?[^>]+(>|$)/g,
                                            ''
                                          );
                                        return (
                                          cleanDescription.slice(0, 50) +
                                          (cleanDescription.length > 50
                                            ? '...'
                                            : '')
                                        );
                                      })()
                                    : 'N/A'}{' '}
                                  <br />
                                  <strong>Data de Criação:</strong>{' '}
                                  {new Date(
                                    protocol.creation_date
                                  ).toLocaleDateString('pt-BR') || 'N/A'}{' '}
                                  <br />
                                  <strong>Cliente:</strong>{' '}
                                  {protocol.cliente?.length > 50
                                    ? `${protocol.cliente.slice(0, 50)}...`
                                    : protocol.cliente || 'N/A'}{' '}
                                  <br />
                                  <strong>Motivo:</strong>{' '}
                                  {protocol.motivo?.length > 50
                                    ? `${protocol.motivo.slice(0, 50)}...`
                                    : protocol.motivo || 'N/A'}{' '}
                                  <br />
                                  <strong>Tipo de Registro:</strong>{' '}
                                  {protocol['tipo de registro']?.length > 50
                                    ? `${protocol['tipo de registro'].slice(
                                        0,
                                        50
                                      )}...`
                                    : protocol['tipo de registro'] || 'N/A'}
                                </div>
                              ),
                              value: {
                                id: protocol.id,
                                recordTypeId: protocol.record_type_id
                              }
                            }))
                          );
                        }}
                        onChange={(selectedOption) => {
                          if (selectedOption) {
                            const protocolId = selectedOption.value.id;
                            const recordTypeId =
                              selectedOption.value.recordTypeId;
                            history.push(
                              `/admin/protocol/${protocolId}/update`,
                              { recordTypeId }
                            );
                          }
                        }}
                      />
                    </NoPaddingDiv>
                    <div>
                      <ProtocolFieldsFilterToggle
                        className="small"
                        onClick={() =>
                          isToShowProtocolFiltersForm(showProtocolFilters)
                        }
                      >
                        {showProtocolFilters ? (
                          <>
                            <FiChevronUp size={18} /> Minimizar filtros{' '}
                          </>
                        ) : (
                          <>
                            <FiChevronDown size={18} /> Maximizar filtros{' '}
                          </>
                        )}
                      </ProtocolFieldsFilterToggle>
                      <span
                        onClick={() => formRef.current.cleanFilters()}
                        className="small"
                        style={{ cursor: 'pointer' }}
                      >
                        <AiOutlineClear /> Limpar filtros
                      </span>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-2">
                  {showProtocolFilters && (
                    <FiltersForm
                      ids={selectedRows}
                      onSelectedRowsChange={setSelectedRows}
                      defaultFields={protocolDefaultFieldsDisplaySettings}
                      handleGetProtocols={handleGetProtocols}
                      handleGetProtocolsOverallSLAInfo={
                        handleGetProtocolsOverallSLAInfo
                      }
                      canSeeAllProtocols={canSeeAllProtocols}
                      dateRules={dateRules}
                      getMediaPath={getMediaPath}
                      quantity={
                        selectedView === 'KANBAN' || selectedView === 'SPLIT'
                          ? kanbanTotalQuantity
                          : parseInt(protocolsQuantity) || 0
                      }
                      ref={formRef}
                      isDisableClickToCall={disableClickToCall}
                      recordTypes={recordTypes}
                      selectedRecordType={selectedRecordType}
                      handleSelectedRecordTypeChange={
                        handleSelectedRecordTypeChange
                      }
                      setShowTable={setSelectedView}
                      showTable={selectedView}
                      setActivePage={setActivePage}
                      activePage={activePage}
                      sortOrder={sortOrder}
                      orderByFilter={orderByFilter}
                      itemsPerPage={itemsPerPage}
                      setItemsPerPage={setItemsPerPage}
                      setTypeReportSelected={setTypeReportSelected}
                      typeReportSelected={typeReportSelected}
                      setDataGrafics={setDataGrafics}
                      setLoaderGrafics={setLoaderGrafics}
                      hasChangedRecordType={hasChangedRecordType}
                      setHasChangedRecordType={setHasChangedRecordType}
                      callBackShowAdvancedFilters={(value) => {
                        setShowAdvancedFilters(value);
                      }}
                      isRecordTypeUsingSLA={isRecordTypeUsingSLA}
                      formatParamsSLAParams={formatParamsSLAParams}
                      isPageReloaded={isPageReloaded}
                      isListenerOnRecordType={isListenerOnRecordType}
                      setIsListenerOnRecordType={setIsListenerOnRecordType}
                      dataField={dataField}
                      onlySubprotocols={onlySubprotocols}
                      setOnlySubprotocols={setOnlySubprotocols}
                    />
                  )}
                </CardBody>

                {isLoadingProtocols ? (
                  <div className="col-12">
                    <Row className="justify-content-md-center">
                      <Loader />
                    </Row>
                  </div>
                ) : (
                  <>
                    {typeReportSelected === 'Analítico' && (
                      <>
                        {columnsReady && selectedView === 'TABLE' && (
                          <div>
                            <FlexTable
                              key={tableKey}
                              data={protocols || []}
                              columns={tableColumns}
                              keyField="id"
                              classes="align-items-center"
                              entityName={`protocols::${selectedRecordTypeId}`}
                              setSortConfig={setSortConfig}
                              sortConfig={sortConfig}
                              showFilterContainer={true}
                              selectRow
                              selectedRows={selectedRows}
                              isSLA={isRecordTypeUsingSLA}
                              slaInfo={protocolOverallSLAInfo}
                              onSelect={(row, checked) => {
                                const newItem = {
                                  id: row.id,
                                  currentStatus: row.current_status ?? null,
                                  number: row.number ?? null,
                                  current_responsible:
                                    row.current_responsible ?? null,
                                  account_id: row.account_id ?? null,
                                  has_unread_comments:
                                    row?.has_unread_comments ?? null
                                };
                                if (checked) {
                                  setSelectedRows((prev) =>
                                    prev.some((r) => r.id === row.id)
                                      ? prev
                                      : [...prev, newItem]
                                  );
                                } else {
                                  setSelectedRows((prev) =>
                                    prev.filter((r) => r.id !== row.id)
                                  );
                                }
                              }}
                              onSelectAll={(checked, rows) => {
                                if (checked) {
                                  const mapped = rows.map((r) => ({
                                    id: r.id,
                                    currentStatus: r.current_status ?? null,
                                    number: r.number ?? null,
                                    current_responsible:
                                      r.current_responsible ?? null,
                                    account_id: r.account_id ?? null
                                  }));
                                  setSelectedRows(mapped);
                                } else {
                                  setSelectedRows([]);
                                }
                              }}
                            />
                            <Pagination
                              activePage={activePage}
                              totalItemsCount={protocolsQuantity}
                              itemsCountPerPage={itemsPerPage}
                              onChange={handlePageChange.bind(this)}
                            />
                          </div>
                        )}
                        {selectedView === 'KANBAN' && (
                          <>
                            <div style={{ marginTop: '18px' }}>
                              <KanbanProtocol
                                data={kanbanDataArray}
                                onTableChange={onTableChange}
                                opportunityStages={status}
                                InfoCard={InfoCardProtocol}
                                isProtocol={true}
                                handleCall={handleCall}
                                disableClickToCall={disableClickToCall}
                                onTableGrow={onTableGrow}
                                stagePageInfo={stagePageInfo}
                              ></KanbanProtocol>
                            </div>
                          </>
                        )}
                        {selectedView === 'SPLIT' && (
                          <div style={{ marginTop: '18px' }}>
                            <ListView
                              data={splitViewData}
                              slaColumnInfo={createSLAColumn}
                              customFields={customFields}
                              handleUpdate={handleUpdate}
                              handleCall={handleCall}
                              disableClickToCall={disableClickToCall}
                              protocolDefaultFieldsDisplaySettings={
                                protocolDefaultFieldsDisplaySettings
                              }
                              stagePageInfo={stagePageInfoSplitView}
                              status={status}
                              onTableGrow={onTableGrowSplitView}
                            ></ListView>
                          </div>
                        )}
                      </>
                    )}
                    {dataGrafics && typeReportSelected === 'Sintético' && (
                      <Graphics protocolsData={dataGrafics} />
                    )}
                  </>
                )}
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ProtocolListing;
